import { BenchmarkIndexWithPerformance } from '@/modules/analysis/benchmarking/common';
import { FundAnalysis, Paginated } from '@/modules/analysis/types';

export const StubClientTotalAum = 300000000000;

export const StubOrganisationInfo = {
  orgName: 'Example Organisation',
  reportingPeriodRange: '1st January 2022 - 31st December 2022',
  formattedAum: '£300bn',
  schemeCount: '597',
  managerCount: '432',
  absPotentialSavings: '£67.42mn'
};

export const StubCBSChartData = [
  {
    name: 'LDI',
    value: StubClientTotalAum * 0.4, // 40%
    itemStyle: { color: '#2EB95F' }
  },
  {
    name: 'Fixed Income',
    value: StubClientTotalAum * 0.25, // 25%
    itemStyle: { color: '#D45087' }
  },
  {
    name: 'Equity',
    value: StubClientTotalAum * 0.25, // 25%
    itemStyle: { color: '#BDE9CC' }
  },
  {
    name: 'Other',
    value: StubClientTotalAum * 0.1, // 10%
    itemStyle: { color: '#2D68FE' }
  }
];

export const StubAssetBuckets: BenchmarkIndexWithPerformance[] = [
  {
    startAUM: 0,
    endAUM: 20000000,
    label: '£0 - 20m AuM',
    units: 'BPS',
    medianPerformance: '0',
    median: '8',
    best_quartile: '4.5',
    worst_quartile: '8.5'
  },
  {
    startAUM: 20000000,
    endAUM: 300000000,
    label: '£20 - 300m AuM',
    units: 'BPS',
    medianPerformance: '0',
    median: '4.5',
    best_quartile: '4',
    worst_quartile: '5'
  },
  {
    startAUM: 300000000,
    endAUM: 500000000,
    label: '£300m+ AuM',
    units: 'BPS',
    medianPerformance: '0',
    median: '2.5',
    best_quartile: '2',
    worst_quartile: '3'
  }
];

export const StubIGGFundAnalysisData: Paginated<FundAnalysis> = {
  data: [
    {
      fundName: 'Fund 38',
      assets_under_management: 6089000,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0022
    },
    {
      fundName: 'Fund 23',
      assets_under_management: 6136638,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0001
    },
    {
      fundName: 'Fund 9',
      assets_under_management: 6228899,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0016
    },
    {
      fundName: 'Fund 37',
      assets_under_management: 6486774,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.0015
    },
    {
      fundName: 'Fund 28',
      assets_under_management: 6816498,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0013
    },
    {
      fundName: 'Fund 10',
      assets_under_management: 6836205,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0012
    },
    {
      fundName: 'Fund 30',
      assets_under_management: 6930096,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0006
    },
    {
      fundName: 'Fund 48',
      assets_under_management: 6970224,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.0004
    },
    {
      fundName: 'Fund 14',
      assets_under_management: 7544937,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0007000000000000001
    },
    {
      fundName: 'Fund 41',
      assets_under_management: 7955086,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0008
    },
    {
      fundName: 'Fund 24',
      assets_under_management: 8009522,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0021
    },
    {
      fundName: 'Fund 8',
      assets_under_management: 8290608,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 5',
      assets_under_management: 8524304,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0001
    },
    {
      fundName: 'Fund 18',
      assets_under_management: 8717991,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0015
    },
    {
      fundName: 'Fund 6',
      assets_under_management: 8849389,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.001
    },
    {
      fundName: 'Fund 50',
      assets_under_management: 8890733,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.0002
    },
    {
      fundName: 'Fund 36',
      assets_under_management: 9227407,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0014099999999999998
    },
    {
      fundName: 'Fund 21',
      assets_under_management: 9699722,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00031
    },
    {
      fundName: 'Fund 31',
      assets_under_management: 9779129,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0014399999999999999
    },
    {
      fundName: 'Fund 16',
      assets_under_management: 9923951,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00037999999999999997
    },
    {
      fundName: 'Fund 26',
      assets_under_management: 10419107,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0008799999999999999
    },
    {
      fundName: 'Fund 17',
      assets_under_management: 10836965,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 3',
      assets_under_management: 10995484,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0009
    },
    {
      fundName: 'Fund 22',
      assets_under_management: 11218864,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00015
    },
    {
      fundName: 'Fund 40',
      assets_under_management: 11450606,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00045
    },
    {
      fundName: 'Fund 7',
      assets_under_management: 12677776,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00128
    },
    {
      fundName: 'Fund 19',
      assets_under_management: 13207381,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00083
    },
    {
      fundName: 'Fund 34',
      assets_under_management: 13244427,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00064
    },
    {
      fundName: 'Fund 45',
      assets_under_management: 14479096,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 46',
      assets_under_management: 14538478,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00017
    },
    {
      fundName: 'Fund 12',
      assets_under_management: 14695239,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00012
    },
    {
      fundName: 'Fund 32',
      assets_under_management: 15392483,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00062
    },
    {
      fundName: 'Fund 20',
      assets_under_management: 15622834,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0005
    },
    {
      fundName: 'Fund 33',
      assets_under_management: 15858628,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00027
    },
    {
      fundName: 'Fund 35',
      assets_under_management: 16774840,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00017999999999999998
    },
    {
      fundName: 'Fund 43',
      assets_under_management: 17172424,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00049
    },
    {
      fundName: 'Fund 44',
      assets_under_management: 17479813,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00046
    },
    {
      fundName: 'Fund 27',
      assets_under_management: 17497259,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0002
    },
    {
      fundName: 'Fund 1',
      assets_under_management: 17518652,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00029
    },
    {
      fundName: 'Fund 4',
      assets_under_management: 17525277,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00041
    },
    {
      fundName: 'Fund 11',
      assets_under_management: 18141252,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00037999999999999997
    },
    {
      fundName: 'Fund 39',
      assets_under_management: 18629939,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00035999999999999997
    },
    {
      fundName: 'Fund 2',
      assets_under_management: 18749806,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00035999999999999997
    },
    {
      fundName: 'Fund 13',
      assets_under_management: 19051876,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00025
    },
    {
      fundName: 'Fund 29',
      assets_under_management: 19707813,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00021
    },
    {
      fundName: 'Fund 47',
      assets_under_management: 19715888,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00013
    },
    {
      fundName: 'Fund 49',
      assets_under_management: 21446645,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0013900000000000002
    },
    {
      fundName: 'Fund 25',
      assets_under_management: 25882992,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00078
    },
    {
      fundName: 'Fund 79',
      assets_under_management: 30248579,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00012
    },
    {
      fundName: 'Fund 42',
      assets_under_management: 32372968,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00148
    },
    {
      fundName: 'Fund 57',
      assets_under_management: 33464474,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 15',
      assets_under_management: 34161340,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00083
    },
    {
      fundName: 'Fund 81',
      assets_under_management: 34297617,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0004
    },
    {
      fundName: 'Fund 61',
      assets_under_management: 35168868,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0013
    },
    {
      fundName: 'Fund 100',
      assets_under_management: 43792795,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00027
    },
    {
      fundName: 'Fund 82',
      assets_under_management: 47886138,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00037999999999999997
    },
    {
      fundName: 'Fund 72',
      assets_under_management: 49903405,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00026
    },
    {
      fundName: 'Fund 53',
      assets_under_management: 53933414,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00026
    },
    {
      fundName: 'Fund 88',
      assets_under_management: 55200277,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00035999999999999997
    },
    {
      fundName: 'Fund 84',
      assets_under_management: 55754026,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00046
    },
    {
      fundName: 'Fund 90',
      assets_under_management: 58908689,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00027
    },
    {
      fundName: 'Fund 64',
      assets_under_management: 60616555,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.0008799999999999999
    },
    {
      fundName: 'Fund 75',
      assets_under_management: 73532479,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0004
    },
    {
      fundName: 'Fund 54',
      assets_under_management: 77795341,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00021999999999999998
    },
    {
      fundName: 'Fund 80',
      assets_under_management: 86864290,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00039
    },
    {
      fundName: 'Fund 89',
      assets_under_management: 87680242,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00024
    },
    {
      fundName: 'Fund 59',
      assets_under_management: 90155062,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00017
    },
    {
      fundName: 'Fund 67',
      assets_under_management: 94592287,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00046
    },
    {
      fundName: 'Fund 76',
      assets_under_management: 104115295,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.001
    },
    {
      fundName: 'Fund 85',
      assets_under_management: 104179178,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00037
    },
    {
      fundName: 'Fund 52',
      assets_under_management: 104528739,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.0004
    },
    {
      fundName: 'Fund 56',
      assets_under_management: 137867661,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00048
    },
    {
      fundName: 'Fund 58',
      assets_under_management: 141215181,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 63',
      assets_under_management: 143727278,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.0012
    },
    {
      fundName: 'Fund 78',
      assets_under_management: 151809164,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00049
    },
    {
      fundName: 'Fund 65',
      assets_under_management: 164113166,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00037999999999999997
    },
    {
      fundName: 'Fund 51',
      assets_under_management: 164274515,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00048
    },
    {
      fundName: 'Fund 73',
      assets_under_management: 174903521,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00046
    },
    {
      fundName: 'Fund 87',
      assets_under_management: 179353510,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00042
    },
    {
      fundName: 'Fund 70',
      assets_under_management: 183436169,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00048
    },
    {
      fundName: 'Fund 62',
      assets_under_management: 191048517,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.0005
    },
    {
      fundName: 'Fund 74',
      assets_under_management: 193427265,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00027
    },
    {
      fundName: 'Fund 86',
      assets_under_management: 195150045,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00032
    },
    {
      fundName: 'Fund 68',
      assets_under_management: 216185721,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00046
    },
    {
      fundName: 'Fund 83',
      assets_under_management: 222120570,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00045
    },
    {
      fundName: 'Fund 60',
      assets_under_management: 256322023,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00043999999999999996
    },
    {
      fundName: 'Fund 66',
      assets_under_management: 259702237,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00043999999999999996
    },
    {
      fundName: 'Fund 77',
      assets_under_management: 270868174,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00027
    },
    {
      fundName: 'Fund 55',
      assets_under_management: 273044104,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00042
    },
    {
      fundName: 'Fund 71',
      assets_under_management: 274279821,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00029
    },
    {
      fundName: 'Fund 69',
      assets_under_management: 298116055,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00024
    },
    {
      fundName: 'Fund 94',
      assets_under_management: 340902555,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00028000000000000003
    },
    {
      fundName: 'Fund 97',
      assets_under_management: 343533580,
      net_return_percent: 0.049,
      annualised_ongoing_charges_percent: 0.00037
    },
    {
      fundName: 'Fund 93',
      assets_under_management: 360818444,
      net_return_percent: -0.055,
      annualised_ongoing_charges_percent: 0.00034
    },
    {
      fundName: 'Fund 99',
      assets_under_management: 391181485,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00041
    },
    {
      fundName: 'Fund 91',
      assets_under_management: 426225239,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.00031
    },
    {
      fundName: 'Fund 98',
      assets_under_management: 439182039,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 0.00017999999999999998
    },
    {
      fundName: 'Fund 92',
      assets_under_management: 452053341,
      net_return_percent: 0.076,
      annualised_ongoing_charges_percent: 0.00025
    },
    {
      fundName: 'Fund 95',
      assets_under_management: 458419839,
      net_return_percent: -0.021,
      annualised_ongoing_charges_percent: 0.0003
    },
    {
      fundName: 'Fund 96',
      assets_under_management: 479249903,
      net_return_percent: 0.011000000000000001,
      annualised_ongoing_charges_percent: 5e-5
    }
  ],
  meta: {
    current_page: 1,
    from: 1,
    last_page: 1,
    per_page: 1000,
    to: 1,
    total: 100
  }
};
